import compose from 'recompose/compose';
import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import SubscriptionPlans from '../components/SubscriptionPlans';
import { getIsReadOnlyAdminUser } from '../../../auth/selectors';
import { fetchAllSubscriptionPlans } from '../actions';
import { getSubscriptionPlans } from '../reducer';

const SubscriptionPlansContainer = compose(
  connect(
    state => ({
      plans: getSubscriptionPlans(state),
      isReadOnlyAdmin: getIsReadOnlyAdminUser(state),
    }),
    { fetchAllSubscriptionPlans }
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchAllSubscriptionPlans();
    },
  })
)(SubscriptionPlans);

export default SubscriptionPlansContainer;
